const LangReportLostCard = {
	"reportLost.copy._message": [
		"Please confirm your mailing list to receive replacement card.",
		"សូម​បញ្ជាក់​​អាសយដ្ឋាន​របស់​លោក​អ្នក​ ដើម្បី​ឲ្យ​យើង​ខ្ញុំ​ផ្ញើ​កាត​ថ្មី​​ជូន​ ។",
	],
	"reportLost.message._updateAddress": [
		"Your address has been updated.",
		"អាសយដ្ឋាន​របស់​លោក​អ្នក ​ត្រូវ​បាន​បញ្ចូល",
	],
}

export default LangReportLostCard



// WEBPACK FOOTER //
// ./src/resources/pages/LangReportLostCard.js